import { DocumentTypeOutputWithStatus } from './document-type-output-with-status.model';


export class DocumentTypeSelectByIdOutput implements IDocumentTypeSelectByIdOutput {
    status!: number;
    message!: string;
    data!: DocumentTypeOutputWithStatus;

    constructor(data?: IDocumentTypeSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DocumentTypeOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DocumentTypeSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentTypeSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDocumentTypeSelectByIdOutput {
    status: number;
    message: string;
    data: DocumentTypeOutputWithStatus;
}

